module.exports = __webpack_public_path__ + "media/images/shared/suppliers/BORGWARNER-c02b17ed599d0e8de9af5f3461bda915.jpg";